export const translations = {
  es: {
    // Navbar
    'nav.subtitle': 'La Molécula de Dios',
    'nav.book': 'El Libro',
    'nav.authors': 'Autores',

    // BookCoverSection
    'bookCover.eyebrow': 'DMT · La Molécula de Dios',
    'bookCover.subtitle': 'Ebook + Audiobook · Acceso inmediato',
    'bookCover.alt': 'DMT: La Molécula de Dios - Portada del libro',

    // HeroSection
    'hero.title.part1': '¿Y si lo que llamas "Dios" no fuera externo…',
    'hero.title.part2':
      'sino una función biológica que nunca aprendiste a activar?',
    'hero.audioWarning': '⚠️ Escucha esto con atención.',
    'hero.audioDescription':
      'Si algo dentro de ti reacciona… entenderás por qué este libro no es casualidad.',
    'hero.priceBefore': 'Antes',
    'hero.limitedTime': 'Por tiempo limitado',
    'hero.priceOnly': 'Solo',
    'hero.instantAccess': '— acceso inmediato',
    'hero.bonusBadge':
      'Acceso inmediato + 3 bonos exclusivos al pagar con tarjeta',
    'hero.cta': 'ACTIVAR MI ACCESO HOY',
    'hero.trustLine':
      'Acceso inmediato · Descarga digital · Garantía de satisfacción',
    'hero.ebook': 'Ebook',
    'hero.audiobook': 'Audiobook',

    // SocialProofSection
    'social.years': '3.000 años',
    'social.yearsDesc': 'de sabiduría chamánica',
    'social.evidence': 'Evidencia',
    'social.evidenceDesc': 'neurocientífica real',
    'social.body': 'Tu cuerpo',
    'social.bodyDesc': 'la produce naturalmente',

    // ProblemSection
    'problem.title.part1':
      '¿Sientes que la realidad tiene una capa más profunda',
    'problem.title.part2': 'pero no sabes cómo verla?',
    'problem.description':
      'Has sentido que algo no encaja. Que hay una profundidad que otros no ven. Pero no sabes cómo cruzar ese puente.',

    // SolutionSection
    'solution.eyebrow': 'Los pilares del libro',
    'solution.title': 'El mecanismo de lo sagrado',
    'solution.pineal.title': 'La Glándula Pineal',
    'solution.pineal.desc':
      'Tu antena biológica hacia dimensiones superiores. El órgano que la ciencia olvidó y que las tradiciones antiguas siempre veneraron.',
    'solution.plant.title': 'Medicina Vegetal',
    'solution.plant.desc':
      'El lenguaje vegetal que habla directamente al alma. Una tecnología ancestral de sanación y revelación que trasciende el tiempo.',
    'solution.quantum.title': 'Física Cuántica',
    'solution.quantum.desc':
      'La ciencia de lo invisible que valida lo sagrado. Donde la materia se disuelve y la conciencia se revela como el fundamento de todo.',
    'solution.integration.title': 'Integración',
    'solution.integration.desc':
      'Cómo vivir despierto en un mundo dormido. Herramientas prácticas para incorporar la experiencia expandida en tu vida cotidiana.',

    // AuthorsSection
    'authors.eyebrow': 'Los autores',
    'authors.title': 'Guías del viaje',
    'authors.subtitle':
      'Más de 10 años explorando la intersección entre ciencia moderna y tradiciones ancestrales.',
    'authors.nicolas.name': 'Nicolás Pereira',
    'authors.nicolas.role': 'Investigador',
    'authors.nicolas.bio':
      'Investigador de estados expandidos de conciencia y neurociencia espiritual. Ha dedicado más de una década a explorar la intersección entre la ciencia moderna y las tradiciones místicas ancestrales.',
    'authors.gabriel.name': 'Gabriel Beltrán',
    'authors.gabriel.role': 'Facilitador',
    'authors.gabriel.bio':
      'Facilitador de ceremonias ancestrales y puente entre mundos. Su experiencia directa con las tradiciones amazónicas le permite traducir lo inefable en palabras que transforman.',
    'authors.tagline':
      '"Escrito desde la experiencia directa, no desde la teoría."',

    // ChaptersSection
    'chapters.eyebrow': '10 capítulos',
    'chapters.title': 'Lo que encontrarás dentro',
    'chapters.chapter': 'Capítulo',
    'chapters.1': 'El Despertar',
    'chapters.2': 'La Molécula Sagrada',
    'chapters.3': 'El Tercer Ojo',
    'chapters.4': 'Voces de la Selva',
    'chapters.5': 'El Puente Cuántico',
    'chapters.6': 'Muerte del Ego',
    'chapters.7': 'El Lenguaje de las Plantas',
    'chapters.8': 'Cartografía Interior',
    'chapters.9': 'La Integración',
    'chapters.10': 'El Retorno',

    // TestimonialsSection
    'testimonials.eyebrow': 'Testimonios reales',
    'testimonials.title': 'Lo que dicen quienes ya lo leyeron',
    'testimonials.readers': '· más de 200 lectores',
    'testimonials.verified':
      'Testimonios verificados de compradores reales del pack Ebook + Audiobook',
    'testimonials.1.name': 'Valentina Ríos',
    'testimonials.1.location': 'Bogotá, Colombia',
    'testimonials.1.text':
      'No sabía si comprarlo. Pensé que era demasiado profundo para mí. Pero fue exactamente lo que necesitaba.',
    'testimonials.2.name': 'Andrés Molina',
    'testimonials.2.location': 'Ciudad de México',
    'testimonials.2.text':
      'Llevo años investigando sobre estados alterados de conciencia y este es el libro más completo y honesto que he leído. La parte sobre la glándula pineal me dejó sin palabras. Totalmente recomendado.',
    'testimonials.3.name': 'Camila Torres',
    'testimonials.3.location': 'Santiago, Chile',
    'testimonials.3.text':
      'El audiobook es una experiencia en sí misma. Escucharlo mientras medito me transporta a otro estado. La voz, el contenido, todo está pensado para que la experiencia sea transformadora.',
    'testimonials.4.name': 'Diego Fernández',
    'testimonials.4.location': 'Buenos Aires, Argentina',
    'testimonials.4.text':
      'Nunca pensé que un libro pudiera hacerme llorar y reír al mismo tiempo. La forma en que conectan la neurociencia con las tradiciones ancestrales es brillante. Mi perspectiva sobre la conciencia cambió para siempre.',
    'testimonials.5.name': 'Sofía Mendoza',
    'testimonials.5.location': 'Lima, Perú',
    'testimonials.5.text':
      'Compré el pack por curiosidad y terminé regalándoselo a mi hermano, mi mamá y dos amigos. Es de esos libros que necesitas compartir. La sección sobre integración es especialmente poderosa.',
    'testimonials.6.name': 'Mateo Vargas',
    'testimonials.6.location': 'Medellín, Colombia',
    'testimonials.6.text':
      'Soy médico y tenía mis dudas sobre el enfoque. Pero la rigurosidad con la que tratan la evidencia científica me sorprendió. Es un libro que respeta tanto al lector espiritual como al racional.',

    // ProductSection
    'product.eyebrow': 'Un pack completo',
    'product.title': 'Ebook + Audiobook incluidos',
    'product.subtitle':
      'No tienes que elegir. Al adquirir el libro recibes ambos formatos: léelo a tu ritmo y escúchalo mientras meditas.',
    'product.included': 'Incluido',
    'product.ebook': 'Ebook',
    'product.ebookFormat': 'Formato digital',
    'product.ebook.1': '10 capítulos completos',
    'product.ebook.2': 'Lectura en cualquier dispositivo',
    'product.ebook.3': 'Descarga inmediata',
    'product.ebook.4': 'Formato PDF + EPUB',
    'product.audiobook': 'Audiobook',
    'product.audiobookFormat': 'Narración inmersiva',
    'product.audiobook.1': 'Narración profesional completa',
    'product.audiobook.2': 'Ideal para meditación y viajes',
    'product.audiobook.3': 'Escucha offline',
    'product.audiobook.4': 'Formato MP3 de alta calidad',
    'product.duration': 'Duración total:',
    'product.hours': '2 horas',
    'product.bundle': 'Ebook + Audiobook — todo en una sola compra',

    // FooterCTA
    'footer.title.part1': '¿Y si la experiencia que otros llaman',
    'footer.title.highlight': '"mística"',
    'footer.title.part2':
      'fuera un estado biológico real que tú también puedes activar?',
    'footer.tagline.part1': 'Este no es solo un libro.',
    'footer.tagline.part2':
      'Es una exploración profunda entre neurociencia, conciencia y percepción.',
    'footer.copyright': '© 2026 Pereira & Beltrán',

    // LanguageSplash
    'splash.title': 'Elige tu idioma',
    'splash.subtitle': 'Choose your language',
    'splash.spanish': 'Español',
    'splash.english': 'English',
  },

  en: {
    // Navbar
    'nav.subtitle': 'The Spirit Molecule',
    'nav.book': 'The Book',
    'nav.authors': 'Authors',

    // BookCoverSection
    'bookCover.eyebrow': 'DMT · The Spirit Molecule',
    'bookCover.subtitle': 'Ebook + Audiobook · Instant Access',
    'bookCover.alt': 'DMT: The Spirit Molecule - Book Cover',

    // HeroSection
    'hero.title.part1': 'What if what you call "God" wasn\'t external…',
    'hero.title.part2':
      'but a biological function you never learned to activate?',
    'hero.audioWarning': '⚠️ Listen carefully.',
    'hero.audioDescription':
      "If something inside you reacts… you'll understand why this book is no coincidence.",
    'hero.priceBefore': 'Was',
    'hero.limitedTime': 'Limited time',
    'hero.priceOnly': 'Only',
    'hero.instantAccess': '— instant access',
    'hero.bonusBadge':
      'Instant access + 3 exclusive bonuses when paying by card',
    'hero.cta': 'ACTIVATE MY ACCESS TODAY',
    'hero.trustLine':
      'Instant access · Digital download · Satisfaction guarantee',
    'hero.ebook': 'Ebook',
    'hero.audiobook': 'Audiobook',

    // SocialProofSection
    'social.years': '3,000 years',
    'social.yearsDesc': 'of shamanic wisdom',
    'social.evidence': 'Evidence',
    'social.evidenceDesc': 'real neuroscience',
    'social.body': 'Your body',
    'social.bodyDesc': 'produces it naturally',

    // ProblemSection
    'problem.title.part1': 'Do you feel that reality has a deeper layer',
    'problem.title.part2': "but you don't know how to see it?",
    'problem.description':
      "You've felt that something doesn't fit. That there's a depth others don't see. But you don't know how to cross that bridge.",

    // SolutionSection
    'solution.eyebrow': 'The pillars of the book',
    'solution.title': 'The mechanism of the sacred',
    'solution.pineal.title': 'The Pineal Gland',
    'solution.pineal.desc':
      'Your biological antenna to higher dimensions. The organ that science forgot and that ancient traditions always revered.',
    'solution.plant.title': 'Plant Medicine',
    'solution.plant.desc':
      'The plant language that speaks directly to the soul. An ancestral technology of healing and revelation that transcends time.',
    'solution.quantum.title': 'Quantum Physics',
    'solution.quantum.desc':
      'The science of the invisible that validates the sacred. Where matter dissolves and consciousness reveals itself as the foundation of everything.',
    'solution.integration.title': 'Integration',
    'solution.integration.desc':
      'How to live awake in a sleeping world. Practical tools to incorporate the expanded experience into your daily life.',

    // AuthorsSection
    'authors.eyebrow': 'The authors',
    'authors.title': 'Guides of the journey',
    'authors.subtitle':
      'More than 10 years exploring the intersection between modern science and ancestral traditions.',
    'authors.nicolas.name': 'Nicolás Pereira',
    'authors.nicolas.role': 'Researcher',
    'authors.nicolas.bio':
      'Researcher of expanded states of consciousness and spiritual neuroscience. He has dedicated more than a decade to exploring the intersection between modern science and ancient mystical traditions.',
    'authors.gabriel.name': 'Gabriel Beltrán',
    'authors.gabriel.role': 'Facilitator',
    'authors.gabriel.bio':
      'Facilitator of ancestral ceremonies and bridge between worlds. His direct experience with Amazonian traditions allows him to translate the ineffable into transformative words.',
    'authors.tagline': '"Written from direct experience, not from theory."',

    // ChaptersSection
    'chapters.eyebrow': '10 chapters',
    'chapters.title': "What you'll find inside",
    'chapters.chapter': 'Chapter',
    'chapters.1': 'The Awakening',
    'chapters.2': 'The Sacred Molecule',
    'chapters.3': 'The Third Eye',
    'chapters.4': 'Voices of the Jungle',
    'chapters.5': 'The Quantum Bridge',
    'chapters.6': 'Ego Death',
    'chapters.7': 'The Language of Plants',
    'chapters.8': 'Inner Cartography',
    'chapters.9': 'The Integration',
    'chapters.10': 'The Return',

    // TestimonialsSection
    'testimonials.eyebrow': 'Real testimonials',
    'testimonials.title': 'What readers are saying',
    'testimonials.readers': '· over 200 readers',
    'testimonials.verified':
      'Verified testimonials from real buyers of the Ebook + Audiobook pack',
    'testimonials.1.name': 'Valentina Ríos',
    'testimonials.1.location': 'Bogotá, Colombia',
    'testimonials.1.text':
      "I wasn't sure if I should buy it. I thought it was too deep for me. But it was exactly what I needed.",
    'testimonials.2.name': 'Andrés Molina',
    'testimonials.2.location': 'Mexico City',
    'testimonials.2.text':
      "I've been researching altered states of consciousness for years and this is the most complete and honest book I've read. The part about the pineal gland left me speechless. Totally recommended.",
    'testimonials.3.name': 'Camila Torres',
    'testimonials.3.location': 'Santiago, Chile',
    'testimonials.3.text':
      'The audiobook is an experience in itself. Listening to it while meditating transports me to another state. The voice, the content, everything is designed to make the experience transformative.',
    'testimonials.4.name': 'Diego Fernández',
    'testimonials.4.location': 'Buenos Aires, Argentina',
    'testimonials.4.text':
      'I never thought a book could make me cry and laugh at the same time. The way they connect neuroscience with ancestral traditions is brilliant. My perspective on consciousness changed forever.',
    'testimonials.5.name': 'Sofía Mendoza',
    'testimonials.5.location': 'Lima, Peru',
    'testimonials.5.text':
      "I bought the pack out of curiosity and ended up giving it to my brother, my mom and two friends. It's one of those books you need to share. The integration section is especially powerful.",
    'testimonials.6.name': 'Mateo Vargas',
    'testimonials.6.location': 'Medellín, Colombia',
    'testimonials.6.text':
      "I'm a doctor and I had my doubts about the approach. But the rigor with which they treat the scientific evidence surprised me. It's a book that respects both the spiritual and rational reader.",

    // ProductSection
    'product.eyebrow': 'A complete pack',
    'product.title': 'Ebook + Audiobook included',
    'product.subtitle':
      "You don't have to choose. When you purchase the book you receive both formats: read it at your own pace and listen while you meditate.",
    'product.included': 'Included',
    'product.ebook': 'Ebook',
    'product.ebookFormat': 'Digital format',
    'product.ebook.1': '10 complete chapters',
    'product.ebook.2': 'Read on any device',
    'product.ebook.3': 'Instant download',
    'product.ebook.4': 'PDF + EPUB format',
    'product.audiobook': 'Audiobook',
    'product.audiobookFormat': 'Immersive narration',
    'product.audiobook.1': 'Complete professional narration',
    'product.audiobook.2': 'Ideal for meditation and travel',
    'product.audiobook.3': 'Listen offline',
    'product.audiobook.4': 'High quality MP3 format',
    'product.duration': 'Total duration:',
    'product.hours': '2 hours',
    'product.bundle': 'Ebook + Audiobook — all in one purchase',

    // FooterCTA
    'footer.title.part1': 'What if the experience others call',
    'footer.title.highlight': '"mystical"',
    'footer.title.part2':
      'was a real biological state that you can also activate?',
    'footer.tagline.part1': 'This is not just a book.',
    'footer.tagline.part2':
      "It's a deep exploration between neuroscience, consciousness and perception.",
    'footer.copyright': '© 2026 Pereira & Beltrán',

    // LanguageSplash
    'splash.title': 'Elige tu idioma',
    'splash.subtitle': 'Choose your language',
    'splash.spanish': 'Español',
    'splash.english': 'English',
  },
} as const

export type TranslationKey = keyof typeof translations.es
export type Language = 'es' | 'en'
